module.exports = __webpack_public_path__ + "static/media/IconTemplates_-46.f7ee2b9f.svg";